<template>
  <div>
    <Header></Header>
    <div class="service">
      <!--企业数字化-->
      <div class="solution-banner-box">
        <div class="content banner-content">
          <div class="ban-left">
            <div data-aos="fade-down">
              <div class="ban-h3">企业数字化</div>
              <div class="ban-h6">让数据成为企业持续发展的驱动力</div>
            </div>
            <div data-aos="fade-up">
              <div class="ban-p">
                企业数字化是指将传统的业务流程、数据和运营转换为数字形式，以实现更高效、更灵活和更创新的运营方式。这种数字化转型通常包括使用数字技术来重新设计和优化业务流程、数字化数据和文档、自动化生产和服务流程、采用云计算、物联网、大数据分析和人工智能等技术来提高企业的生产力、效率和创新能力。更好地适应市场变化和满足客户需求，同时也可以提高企业的效率和盈利能力。
              </div>
            </div>
          </div>
          <div data-aos="fade-up" style="visibility: hidden;">
            <div class="ban-right">
              <img
                :src="
                  require(`../../assets/images/solution/img_jjfa_zhcs_topimg.png`)
                "
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section section-1" v-if="false">
        <div class="content section-content">
          <h3 class="section-h3">方案理念</h3>
          <h6 class="section-h6">SOLUTION CONCEPT</h6>
          <div class="section-flex">
            <div data-aos="fade-up" data-aos-delay="100">
              <div class="flex-item">
                <div class="item-icon icon-1"></div>
                <div class="item-tips">平台经济</div>
                <div class="item-h">创新商业模式<br /></div>
                <div class="item-p">打造竞争力强的平台,赋能企业<br />…</div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
              <div class="flex-item">
                <div class="item-icon icon-2"></div>
                <div class="item-tips">价值链</div>
                <div class="item-h">
                  串联数据价值链
                </div>
                <div class="item-p">聚合上中下游产业数据,完善服务<br />…</div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="500">
              <div class="flex-item">
                <div class="item-icon icon-3"></div>
                <div class="item-tips">工作流程</div>
                <div class="item-h">
                  构建快速响应工作流程
                </div>
                <div class="item-p">重组工作环节,确保灵活、高效<br />…</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-1">
        <div class="content section-content">
          <h3 class="section-h3">为中小型企业数字化排忧解难</h3>
          <h6 class="section-h6">
            SOLVE PROBLEMS FOR SMALL AND MEDIUM-SIZED ENTERPRISES
            DIGITALIZATIONS
          </h6>
          <div class="section-flex">
            <div data-aos="fade-up" data-aos-delay="100">
              <div class="flex-item">
                <div class="item-icon icon-1"></div>
                <div class="item-tips">不会转</div>
                <div class="item-h">缺指导、转型难度大<br /></div>
                <!-- <div class="item-p">打造竞争力强的平台,赋能企业<br />…</div> -->
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
              <div class="flex-item">
                <div class="item-icon icon-2"></div>
                <div class="item-tips">不管转</div>
                <div class="item-h">
                  协同差、成果见效慢
                </div>
                <!-- <div class="item-p">聚合上中下游产业数据,完善服务<br />…</div> -->
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="500">
              <div class="flex-item">
                <div class="item-icon icon-3"></div>
                <div class="item-tips">不能转</div>
                <div class="item-h">
                  基础弱、转型成本高
                </div>
                <!-- <div class="item-p">重组工作环节,确保灵活、高效<br />…</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-1 bg-light-purple" v-if="false">
        <div class="content section-content">
          <h3 class="section-h3">方案内容</h3>
          <h6 class="section-h6">PROGRAM CONTENT</h6>
          <div data-aos="fade-up">
            <div class="hc-list">
              <ul>
                <li>
                  <span>
                    1.业务流程评估:通过对企业现有业务流程的分析和评估，识别和理解业务流程中存在的痛点和问题。评估的重点包括业务流程的效率、自动化程度、信息传递和沟通的效果等方面。
                  </span>
                  <span>
                    2.技术基础设施评估:评估企业现有的技术基础设施，包括硬件软件、网络等方面。通过评估，确定技术基础设施的健康状况和潜在的风险，并提供相应的改进方案和建议。
                  </span>
                  <span>
                    3.数据分析和挖掘评估:评估企业对数据的收集、存储、分析和挖掘能力。通过评估，确定企业对数据的利用程度和潜在的改进空间并提供相应的数据分析和挖掘方案。
                  </span>
                  <span>
                    4.组织结构和文化评估:评估企业的组织结构和文化，包括决策层的支持程度、人员培训和意识、团队合作等方面。通过评估，确定组织结构和文化对数字化转型的影响，并提供相应的改进建议。
                  </span>
                  <span>
                    5.竞争力评估:评估企业在数字化转型方面的竞争力，包括市场地位、技术创新能力、客户关系管理等方面。通过评估，确定企业在数字化转型中的优势和劣势，并提供相应的竞争力提升方案。
                  </span>
                  <span>
                    6.风险评估:评估数字化转型过程中存在的风险和挑战，包括技术风险、数据安全风险、组织变革风险等方面。通过评估，确定潜在的风险和应对策略，并提供相应的风险管理方案。
                  </span>
                  <span>
                    7.转型路线图:基于评估结果，制定数字化转型的路线图和计划路线图应包括转型目标、时间表、资源需求和关键里程碑等方面以指导企业顺利进行数字化转型。
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-1 bg-light-purple" v-if="false">
        <div class="content section-content">
          <h3 class="section-h3">产品应用</h3>
          <h6 class="section-h6">PRODUCT APPLICATION</h6>
          <div data-aos="fade-up">
            <div class="hc-grid">
              <ul>
                <li>
                  <span>物业管理</span>
                  <span>移动OA</span>
                  <span>招商管理</span>
                  <span>私域平台</span>
                  <span>客户管理</span>
                </li>
                <li>
                  <span>能耗管理</span>
                  <span>门禁管理</span>
                  <span>消防管理</span>
                  <span>租赁管理</span>
                  <span>资产管理</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-2 bg-light-purple" v-if="false">
        <div class="content section-content">
          <h3 class="section-h3">顶层架构</h3>
          <h6 class="section-h6">TOP ARCHITECTURE</h6>
          <div data-aos="fade-up">
            <div class="info-container">
              <img
                :src="
                  require(`../../assets/images/solution/img_jjfa_zhyq_dcjg.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="tec-box">
            <div data-aos="fade-up" data-aos-delay="100">
              <div class="tec-item tec-item-1">
                <div class="tips-en">BIG DATA</div>
                <div class="tips-ch">大数据</div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
              <div class="tec-item tec-item-2">
                <div class="tips-en">INTERNET OF THINGS</div>
                <div class="tips-ch">物联网</div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="500">
              <div class="tec-item tec-item-3">
                <div class="tips-en">ARTIFICIAL INTELLIGENCE</div>
                <div class="tips-ch">人工智能</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2-1">
        <div data-aos="fade-up" data-aos-delay="300">
          <img class="rf-model-img" :src="background" />
        </div>
      </div>
      <div class="section section-3" v-if="false">
        <div class="content section-content">
          <h3 class="section-h3">方案特点</h3>
          <h6 class="section-h6">PROGRAM FEATURES</h6>
          <div class="section-flex">
            <div data-aos="fade-up" data-aos-delay="100">
              <div class="flex-item item-1">
                <div class="left">1·服务</div>
                <div class="right">
                  从顶层规划的理念出发，构建契合城市实际和特色的一整套企业数字化的综合信息服务体系。
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
              <div class="flex-item item-2">
                <div class="left">2·平台</div>
                <div class="right">
                  构建两大支撑平台，能够支撑企业数字化建设的城市云计算平台和企业数字化大数据融合服务平台。
                </div>
              </div>
            </div>
            <div data-aos="fade-up" data-aos-delay="500">
              <div class="flex-item item-n">
                <div class="left">N·应用</div>
                <div class="right">
                  搭建涵盖城市运行体征、民生民情、生态环境、水文水利等多项应用体系，形成企业数字化的完整生态系统。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-4">
        <div class="content section-content">
          <h3 class="section-h3">睿峰数字化过程</h3>
          <h6 class="section-h6">PROGRAM PROCESS BY RFHC</h6>
          <div class="section-flex" data-aos="fade-up" data-aos-delay="300">
            <img class="rf-model-img" :src="process" />
          </div>
        </div>
      </div>
      <div class="section section-5">
        <div class="content section-content">
          <h3 class="section-h3">数字化服务计划</h3>
          <h6 class="section-h6">DIGITAL SERVICE PLAN</h6>
          <div class="section-flex" data-aos="fade-up" data-aos-delay="300">
            <img class="rf-model-img" :src="service" />
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";
export default {
  name: "SolutionCity",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      background: require("../../assets/images/home-content-model-bg.png"),
      process: require("../../assets/images/solution/diagital-process-content.png"),
      service: require("../../assets/images/solution/diagital-service-content.png")
    };
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/solution";

.rf-model-img {
  width: 100%;
  object-fit: contain;
}
</style>
